import * as React from 'react';
import { IconButton } from '@material-ui/core';

export interface AppIconButtonProps {
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
    title?: string;
    id?: string;
    className?: string;
    style?: React.CSSProperties;
    size?: 'small' | 'medium';
    children?: React.ReactNode;
}

const AppIconButton: React.FC<AppIconButtonProps> = ({
    onClick,
    disabled,
    title,
    id,
    className,
    style,
    size = 'small',
    children,
}) => {
    return (
        <IconButton
            id={id}
            title={title}
            disabled={disabled}
            onClick={onClick}
            size={size}
            className={className}
            style={{
                aspectRatio: '1 / 1',
                borderRadius: '4px',
                ...style,
            }}
        >
            {children}
        </IconButton>
    );
};

export default AppIconButton;
